import { Injectable } from '@angular/core';

@Injectable()
export class DocumentQueryService {

  constructor() { }

  /**
   * id : ID for selector in document.querySelector
   * 
   * When use document.querySelector with ID configured by only numbers,
   * Error occured with invalid selector format,
   * So use this function for avoid that error.
   * 
   * e.g) document.querySelector(idSelector('#12345'))
   */
  getCleanSelectorId(id) {
    (id.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n){
        id = id.replace(n, '[id="' + n.replace("#", "") + '"]');
    });
    return id;
  }

  /**
   * Execute document's querySelector with Clean Selector Only ID
   */
  queryIDSelector(id: string) {
    return document.querySelector(this.getCleanSelectorId(id));
  }

  queryIDMultiSelector(mainId: string, restSelector: string) {
    return document.querySelector(this.getCleanSelectorId(mainId) + ' ' + restSelector);
  }

  queryAllIDMultiSelector(mainId: string, restSelector: string) {
    return document.querySelectorAll(this.getCleanSelectorId(mainId) + ' ' + restSelector);
  }

  /**
   * Scroll to 1st parameter element
   * 
   * element : What you want to scroll to
   * to : Scroll value
   * duration : Time taken to scroll.
   */
  scrollTo(queryTarget: string
  // , to: number, duration: number
  ) {
    let element: HTMLElement;
    if (queryTarget.indexOf('#') >= 0) {
      const mainId: string = queryTarget.split(' ')[0];
      let restSelector: string = queryTarget.substr(queryTarget.indexOf(' '), queryTarget.length);
      if (restSelector) {
        restSelector = restSelector.trim();
      }
      element = <HTMLElement>this.queryIDMultiSelector(mainId, restSelector);
    } else {
      element = document.querySelector(queryTarget);
    }

    // element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    element.scrollIntoView();
    // var start = element.scrollTop,
    //     change = to - start,
    //     currentTime = 0,
    //     increment = 20;
        
    // var animateScroll = () => {
    //     currentTime += increment;
    //     var val = this.MatheaseInOutQuad(currentTime, start, change, duration);
    //     element.scrollTop = val;
    //     if(currentTime < duration) {
    //         setTimeout(animateScroll, increment);
    //     }
    // };
    // animateScroll();
  }

  

  //t = current time
  //b = start value
  //c = change in value
  //d = duration
  MatheaseInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  };

  valueValidate(mainId: string, restSelector: string, useTimer: boolean = false, timer: number = 1000) {
    const basiccolor = 'transparent';
    const color = 'red';
    const time = 0.5;
    const keyframeCss = '@keyframes blink { 0%, 100% { outline: none; border-width: 0px; border-color: ' + basiccolor + '; } 50% { border-width: 3px; border-color: ' + color + '; } }';
    const timingCss = '.blink-border { animation: blink ' + time + 's; } ';
    const keyframeCssName = 'keyframeCss';
    const timingCssName = 'timingCss';

    const findKeyFrameCss = document.querySelector('#' + keyframeCssName) != null;
    const findTimingCss = document.querySelector('#' + timingCssName) != null;

    if (!findKeyFrameCss) {
      const keyframeCssElement = document.createElement('style');
      keyframeCssElement.id = keyframeCssName;
      document.head.appendChild(keyframeCssElement).textContent = keyframeCss;
    }

    if (!findTimingCss) {
      const timingCssElement = document.createElement('style');
      timingCssElement.id = timingCssName;
      document.head.appendChild(timingCssElement).textContent = timingCss;
    }

    const element = document.querySelector(this.getCleanSelectorId(mainId) + ' ' + restSelector);
    if (!element) {
      return;
    }

    (<HTMLElement>element).focus();
    if (element instanceof HTMLInputElement) {
      element.classList.add('red-border');
      if (useTimer) {
        setTimeout(() => {
          element.classList.remove('red-border');
        }, timer);
      } else {
        element.addEventListener('focusout', () => {
          if (element instanceof HTMLInputElement &&
                element.value !== '') {
            element.classList.remove('red-border');
          }
        });
      }
    } else {
      element.classList.add('blink-border');
      setTimeout(() => {
        element.classList.remove('blink-border');
      }, 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/documentquery.service.ts